<template>
  <v-container fluid fill-height class="d-flex">
    <v-layout justify-center align-start>
      <v-flex lg8 md10 sm11 xs12>
        <v-card class="br-10 pa-4">
          <span class="title pb-3"><strong>{{ $t('ticket_history') }}</strong></span>
          <v-data-iterator content-tag="v-layout" row wrap :items="list" :items-per-page="10">
            <!-- <v-layout slot="item" slot-scope="props" xs12 sm12 md12 lg4 class="d-flex"> -->
              <v-row slot="item" slot-scope="props">
                <v-col sm="12" md="6" lg="4">
                  <v-card class="elevation-0">
                    <v-card-title>
                      <span class="body-2 font-weight-bold">{{ props.item.updated_at | dateTime }}</span>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                      <v-list-item @click="$router.push('/ticket/detail/' + props.item._id)">
                        <v-list-item-content style="width: 50%">{{ $t('reference_no') }}:</v-list-item-content>
                        <v-list-item-content style="width: 50%; text-decoration: underline;" class="font-weight-bold primary--text">{{ props.item._id.split("-")[props.item._id.split("-").length - 1] }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content style="width: 50%">{{ $t('status') }}:</v-list-item-content>
                        <v-list-item-content style="width: 50%" class="font-weight-bold" :class="{ 'green--text': props.item.status === 'new' }">{{ $t(props.item.status) }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content style="width: 50%">{{ $t('title') }}:</v-list-item-content>
                        <v-list-item-content style="width: 50%" class="font-weight-bold">{{ $t(props.item.title) | capitalize }}</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            <!-- </v-layout> -->
          </v-data-iterator>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from '../../axios'
import configuration from '../../configurations'
import vuex from 'vuex'

export default {
  computed: {
    ...vuex.mapState({
      // list: state => state.ticket.list,
      iterator: state => state.ticket.iterator
    })
  },
  data: () => ({ bookmark: null, list: [], loading: false, selector: {} }),
  created: async function () {
    let fetchSession = await this.$store.dispatch('auth/session')
    if (!fetchSession.userCtx.name || fetchSession.userCtx.name.length === 0 || fetchSession.userCtx.name === 'couchdb') {
      this.$router.go(-1)
      this.$store.dispatch('snackbar/setSnackBar', {
        color: 'error',
        message: 'Pengguna tidak dijumpai. Sila log masuk semula.',
        visible: true
      })
      return
    }
    this.selector = {
      type: 'ticket',
      customer_ic: fetchSession.userCtx.ic_num,
      customer_email: fetchSession.userCtx.name
    }
    await this.fetchList(true)
  },
  methods: {
    async fetchList (reset = true) {
      this.loading = true
      if (reset) {
        this.bookmark = null
        this.list = []
      }
      try {
        const query = {}
        query.use_index = 'indexes/ticket'
        query.selector = this.selector
        query.limit = 100
        if (this.bookmark) query.bookmark = this.bookmark
        const result = await axios({
          url: `${configuration.WORKER}/tickets/find`,
          method: 'POST',
          data: query
        })
        if (result.data.docs.length > 0) {
          this.list = this.list.concat(result.data.docs)
          this.bookmark = result.data.bookmark
          await this.fetchList(false)
        }
      } catch (error) {
        console.log(error)
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Failed to fetch data',
          visible: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
